export default __webpack_public_path__ + "static/media/6MD61.c4604cba.png";